<template>
        <!-- not chrome dialog Dialog -->
	<div>
		<div v-if="!isChrome && $browserDetect.meta.ua && !smallScreen" class="browser-warning text-center">{{ $t('You seem not using a compatible browser') }},
			<span>{{ $t('Use Grafias with Chrome ') }}
				<a href="https://www.google.co.id/chrome/?brand=CHBD&gclid=CjwKCAjwiOv7BRBREiwAXHbv3AWBmeej6mPeNXp8FwCu2rVTeVyKHmOTY8PZwdTt57cJPs2tReOVzBoCC8YQAvD_BwE&gclsrc=aw.ds"
					target="_blank" class="underline pointer text-white">{{$t('Download here')}}</a>
			</span>
		</div>
        <!-- <modal
            class="offline-modal"
            size="small-medium"
            @close="close"
            v-if="!isChrome">
            <template slot="header">
                <h5 class="mb-0">{{ $t('Warning') }}</h5>
            </template>
            <template slot="body">
                <div class="text-center">
                    <p class="material-icons-warning md-18 text-center">warning</p>
                </div>
                <p class="mb-2 text-center text-base">{{ `${$t('You seems using')} ${browserName} - Version ${browserVersion}` }},</p>
                <p class="mb-4 text-center text-sm">{{ $t('For Best Experiences It\'s Recomended to Use Chrome Browser') }}</p>
                <div class="text-center">
                    <button
                        @click="close"
                        type="submit"
                        class="btn btn-submit btn-primary text-center">
                        {{ $t('Close') }}
                    </button>
                </div>
            </template>
            <div slot="footer" class="text-center">
            </div>
		</modal> -->
	</div>
</template>

<script>

// import DetectedSpeed from 'vue-identify-network';
// import Modal from '@/components/Modal.vue';

export default {
	name: 'IdentifyBrowser',
	components: {
		// DetectedSpeed,
		// Modal,
	},
	props: {},
	mounted() {
		this.browserName = this.$browserDetect.meta.name;
		this.browserVersion = this.$browserDetect.meta.version;
		window.addEventListener('resize', this.onResizeWidth);
		this.onResizeWidth();
	},
	data: () => ({
		isChrome: true,
		browserName: '',
		browserVersion: '',
		smallScreen: false,
	}),
	created() {
		window.addEventListener('resize', this.onResizeWidth);
		this.onResizeWidth();
		if (this.activeRouteNameWithoutLive) {
			if (this.$browserDetect.meta.ua.indexOf('Edg') === 116) {
				this.isChrome = false;
			} else if (this.$browserDetect.isChrome || this.$browserDetect.isChromeIOS) {
				this.isChrome = true;
			} else {
				this.isChrome = false;
			}
		}
	},
	methods: {
		close() {
			this.isChrome = true;
		},
		detectBrowser() {
		},
		onResizeWidth() {
			if (window.innerWidth <= 1024) {
				this.smallScreen = true;
			} else {
				this.smallScreen = false;
			}
		},
	},
	watch: {
		activeRouteName() {
			if (this.activeRouteNameWithoutLive) {
				if (this.$browserDetect.meta.ua.indexOf('Edg') === 116) {
					this.isChrome = false;
				} else if (this.$browserDetect.isChrome || this.$browserDetect.isChromeIOS) {
					this.isChrome = true;
				} else {
					this.isChrome = false;
				}
			}
		},
	},
	computed: {
		activeRouteName() {
			return this.$route.name;
		},
		activeRouteNameWithoutLive() {
			return this.activeRouteName
				&& this.activeRouteName !== ''
				&& !this.activeRouteName.includes('Display')
				&& !this.activeRouteName.includes('Live')
				&& !this.activeRouteName.includes('Preview')
				&& !this.activeRouteName.includes('CompositionEditorView');
		},
	},
	beforeDestroy() {

	},
};
</script>

<style lang="scss" scoped>
.material-icons-warning {
    font-family: 'Material Icons';
    font-weight: normal;
    font-style: normal;
    font-size: 80px;
	color: #FFA800;
    line-height: 1;
    letter-spacing: normal;
    text-transform: none;
    display: inline-block;
    white-space: nowrap;
    word-wrap: normal;
    direction: ltr;
    -webkit-font-feature-settings: 'liga';
    -webkit-font-smoothing: antialiased;
}
.wrapper-offline{
		text-align: center!important;
	}
</style>
